import {getToken} from './JwtService';

const API_SERVER = process.env.VUE_APP_API_SERVER;
const API_BASE_URL = 'api/v1';

export default class ApiService {
    constructor(options = {}) {
        this.server = options.server || API_SERVER;
        this.baseUrl = options.baseUrl || API_BASE_URL;
    }

    createHeaders() {
        let headers = {
            'Content-Type': 'application/json'
        };

        let token = getToken();
        if (token) headers['Authorization'] = 'Bearer ' + token;

        return headers;
    }

    createRequest(method, body) {
        let request = {
            method: method,
            credentials: 'same-origin',
            headers: this.createHeaders(),
            body: JSON.stringify(body)
        };

        return request;
    }

    async get(resource, slug = '') {
        let url = `${this.server}/${this.baseUrl}/${resource}/${slug}`;
        let response = await fetch(url, this.createRequest('GET'));
        return await response.json();
    }

    async post(resource, params) {
        let url = `${this.server}/${this.baseUrl}/${resource}`;
        let response = await fetch(url, this.createRequest('POST', params));
        return await response.json();
    }

    async put(resource, params) {
        let url = `${this.server}/${this.baseUrl}/${resource}`;
        let response = await fetch(url, this.createRequest('PUT', params));
        return await response.json();
    }

    async delete(resource, slug) {
        let url = `${this.server}/${this.baseUrl}/${resource}/${slug}`;
        let response = await fetch(url, this.createRequest('DELETE'));
        return await response.json();
    }
}